import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { NavLink, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import sortBy from 'lodash/sortBy'

class OfficeList extends Component {
  static propTypes = {
    offices: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    activeTab: PropTypes.string
  }

  isOfficeFilterActive = () => {
    return this.props.activeTab === 'Office'
  }

  renderOfficeList (activeTab, offices) {
    const classes = this.isOfficeFilterActive()
      ? 'client-search-list-item'
      : 'client-search-list-item-all--office'

    offices = sortBy(offices, 'officeName')
    return offices.map(office => (
      <div key={office.id} className={classes}>
        {this.renderNavLink(office)}
      </div>
    ))
  }

  renderNavLink (office) {
    const classes = this.isOfficeFilterActive()
      ? 'client-search-list-item--account'
      : ''

    return (
      <NavLink
        to={`/client-search/office/${office.id}`}
        activeStyle={{ color: '#ff6d2a' }}
      >
        <p className={classes}>{office.officeName}</p>
      </NavLink>
    )
  }

  render () {
    const { activeTab, offices } = this.props

    return <div>{this.renderOfficeList(activeTab, offices)}</div>
  }
}

export default withRouter(observer(OfficeList))
